// start:ng42.barrel
export * from './chart-options.pipe';
export * from './dashboard-header.pipe';
// end:ng42.barrel

